import Yup from '@fourthwall/utils/dist/yup';
import { FormFields } from './GenerateCodesModal.types';
export const validationSchema = Yup.object().shape({
    [FormFields.quantity]: Yup.number().required().min(1).max(10000),
    [FormFields.prefix]: Yup.string(),
});
